import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <div>
          <h1>Hello World! 🌍</h1>
          <p>Мой первый космический корабль!</p>
        </div>
      </header>
    </div>
  );
}

export default App;
